import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface CheckboxQuestionProps {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
}

export const CheckboxQuestion = ({ options, value, onChange }: CheckboxQuestionProps) => {
  const handleCheckboxChange = (option: string, checked: boolean) => {
    if (checked) {
      onChange([...value, option]);
    } else {
      onChange(value.filter((item) => item !== option));
    }
  };

  return (
    <div className="space-y-3">
      {options.map((option) => (
        <div key={option} className="flex items-center space-x-2">
          <Checkbox
            id={option}
            checked={value.includes(option)}
            onCheckedChange={(checked) => handleCheckboxChange(option, checked as boolean)}
            className="border-green-500 data-[state=checked]:bg-green-500 data-[state=checked]:text-white"
          />
          <Label htmlFor={option} className="text-foreground">{option}</Label>
        </div>
      ))}
    </div>
  );
};